import { url } from "../../Common/common";
import moment from 'moment-timezone';

export function savePhotoOrder(pars, callback) {
    // console.log('savePhotoOrder', pars)
    let formData = new FormData();
    formData.append("avatar", pars.photo);
    formData.append('user_id', pars.user_id)
    formData.append('doctor_id', pars.doctor_id)
    fetch(url + '/saveorderphoto', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}


export function getUserOrders(pars, callback) {
    console.log('getUserOrders', pars)
    let formData = new FormData();
    formData.append("user_id", pars.user_id);
    formData.append("profession", pars.profession);
    formData.append("doctor_id", pars.doctor_id);

    // fetch(url + '/getuserorders', {
    fetch(url + '/getdoctororders', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('orders', data)
        return callback(data)
    })
    .catch((err) => console.log('err', err))
}

export function getOrderPhotos(pars, callback) {
    console.log('getOrderPhotos', pars)
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    
    fetch(url + '/getorderphotos', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data', data)
        return callback(data)
    });
}

export function getOrderFiles(pars, callback) {
    console.log('getOrderFiles pars', pars)
    let formData = new FormData();
    formData.append("order_id", pars.order_id);

    fetch(url + '/getorderfiles', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('getOrderFiles data', data)
        return callback(data);
    })
    .catch((error) => {
        console.error('Ошибка при получении файлов:', error);
        callback({ res: false, error });
    });
}


export function getHasCustomPrices(pars, callback) {
    console.log('getHasCustomPrices', pars)
    let formData = new FormData();
    formData.append("user_id", pars.user_id);
    if (pars.doctor_id) {
        formData.append("doctor_id", pars.doctor_id);
    }

    fetch(url + '/hascustomprices', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        return callback(data);
    })
    .catch((error) => {
        console.error('Error fetching hasCustomPrices:', error);
        return callback({ res: false, reason: 'Fetch error' });
    });
}


export function deactivateOrder(pars, callback) {
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    
    fetch(url + '/deactivateOrder', {
        method: 'POST',
        body: formData,
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
    .then((data) => {
        return callback(data);
    })
    .catch((error) => {
        console.error('Error during order deactivation:', error);
        callback({ res: false, error: error.message });
    });
}


export function saveOrderCard(pars, callback) {
    console.log('saveOrderCard', pars.date_delivery, moment(pars.date_delivery).format("YYYY-MM-DD"))
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    formData.append("pacient", pars.pacient);
    formData.append("color", pars.color);
    formData.append("price", pars.price);

    formData.append("paid", pars.paid);
    // formData.append("date_delivery", pars.date_delivery.toISOString().split('T')[0]);
    formData.append("date_delivery", moment(pars.date_delivery).format("YYYY-MM-DD"));

    formData.append("type_pay", pars.type_pay);
    formData.append("technic_id", pars.technic_id);
    
    fetch(url + '/saveorder', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}


export function addPhotoOrder(formData, callback) {
  console.log('addPhotoOrder:');
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }

  fetch(url + '/addphotoorder', {
    method: 'POST',
    body: formData, // уже готовый FormData
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((err) => console.error('Ошибка при загрузке фото:', err));
}


export function addAudioOrder(pars, callback) {

    console.log('addAudioOrder', pars)

    let formData = new FormData();

    formData.append("avatar", pars.audio);

    formData.append('order_id', pars.order_id)

    fetch(url + '/addaudioorder', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data', data)
        return callback(data)
    });
}

export function addCommentOrder(pars, callback) {

    // console.log('addAudioOrder', pars)

    let formData = new FormData();

    formData.append('order_id', pars.order_id)
    formData.append('text', pars.text)

    fetch(url + '/addcommentorder', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function addFileOrder(pars, callback) {
    // pars: { file: выбранный файл из DocumentPicker, order_id: id заказа }
    let formData = new FormData();

    formData.append("file", {
        uri: pars.file.uri,                     // путь к файлу
        type: pars.file.mimeType || 'application/octet-stream',  // MIME тип
        name: pars.file.name || 'file.dat'      // имя файла
    });

    formData.append('order_id', pars.order_id); 

    fetch(url + '/addfileorder', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        return callback(data);
    })
    .catch((error) => {
        console.error('Ошибка при отправке файла:', error);
    });
}

export function deleteAudioOrder(pars, callback) {
  // pars: { audio_id: id аудио, order_id: id заказа }
  let formData = new FormData();
  formData.append('audio_id', pars.audio_id);
  formData.append('order_id', pars.order_id);

  fetch(url + '/deleteaudioorder', {
    method: 'POST',
    
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      return callback(data);
    })
    .catch((error) => {
      console.error('Ошибка при удалении аудио:', error);
      return callback({ res: false, error });
    });
}


export function getOrderAudios(pars, callback) {
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    
    fetch(url + '/getorderaudios', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}


export function getOrderComments(pars, callback) {
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    
    fetch(url + '/getordercomments', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function deleteCommentOrder(pars, callback) {
    let formData = new FormData();
    formData.append("id", pars.id); // id комментария

    fetch(url + '/deletecommentorder', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        return callback(data);
    })
    .catch((error) => {
        console.error('Ошибка при удалении комментария:', error);
        return callback({ res: false, error });
    });
}



export function getPricePart(pars, callback) {
    let formData = new FormData();
    formData.append("customer_id", pars.customer_id);

    fetch(url + '/getpricepart', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        return callback(data);
    })
    .catch((err) => {
        console.error("Ошибка при получении price_part:", err);
    });
}


export function savePriceDoctor(pars, callback) {
    let formData = new FormData();
    formData.append("works", JSON.stringify(pars.works));
    formData.append("doctor_id", JSON.stringify(pars.doctor_id));
    // console.log('savePriceDoctor')
    fetch(url + '/savepricedoctor', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function deletePriceWork(pars, callback) {
    let formData = new FormData();
    formData.append("id", pars.id);
    fetch(url + '/deletepricework', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function getPricePartWorks(pars, callback) {
    console.log('getPricePartWorks', pars)
    let formData = new FormData();
    formData.append("part_id", pars.id);
    formData.append("doctor_id", pars.doctor_id);
    // console.log('getPricePartWorks')
    fetch(url + '/getpricepartworks', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data', data)
        return callback(data)
    });
}

export function newPriceWork(pars, callback) {
    let formData = new FormData();
    formData.append("part_id", pars.part_id);
    formData.append("default_price", pars.default_price);
    formData.append("name", pars.name);
    // console.log('newPriceWork')
    fetch(url + '/newpricework', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function savePricePart(pars, callback) {
    let formData = new FormData();
    formData.append("part_id", pars.part_id);
    formData.append("name", pars.name);
    // console.log('newPriceWork')
    fetch(url + '/savepricepart', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function deletePricePart(pars, callback) {
    let formData = new FormData();
    formData.append("part_id", pars.part_id);
    // console.log('newPriceWork')
    fetch(url + '/deletepricepart', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function newPricePart(pars, callback) {
    let formData = new FormData();
    formData.append("name", pars.name);
    formData.append("customer_id", pars.customer_id);
    // console.log('newPricePart')
    fetch(url + '/newpricepart', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('newpricepart data', data)
        return callback(data)
    });
}

export function setIsPaid(pars, callback) {
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    formData.append("paid", pars.paid);
    formData.append("prepaid", pars.prepaid);
    
    fetch(url + '/setispaid', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}

export function setCancelPaid(pars, callback) {
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    
    fetch(url + '/setcancelpaid', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    });
}


export function deleteOrder(pars, callback) {
    let formData = new FormData();
    formData.append("order_id", pars.order_id);
    fetch(url + '/delorder', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data getDoctors', data)
        return callback(data)
    });
}


export function deletePhoto(pars, callback) {
    let formData = new FormData();
    formData.append("id", pars.id);
    fetch(url + '/delphoto', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data getDoctors', data)
        return callback(data)
    });
}

export function newTechnic(pars, callback) {
    // console.log('newtechnic')
    let formData = new FormData();
    formData.append("name", pars.name);
    formData.append("surname", pars.surname);
    formData.append("company", pars.company);
    formData.append("user_id", pars.user_id);
    fetch(url + '/newtechnic', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data newTechnic', data)
        return callback(data)
    });
}

export function updateTechnic(pars, callback) {
    // console.log('updateTechnic')
    let formData = new FormData();
    formData.append("comission", pars.comission);
    formData.append("name", pars.name);
    formData.append("surname", pars.surname);
    formData.append("user_id", pars.user_id);
    fetch(url + '/updatetechnic', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data updatetechnic', data)
        return callback(data)
    });
}

export function deleteTechnic(pars, callback) {
    let formData = new FormData();
    formData.append("id", pars.id);
    fetch(url + '/deletetechnic', {
        method: 'POST',
        
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        // console.log('data getDoctors', data)
        return callback(data)
    });
}



